ceregoCommon.factory('CategoriesResource', ['$resource', ($resource) ->
  $resource "",{},
    get:
      method: 'GET'
      isArray: false
      url: APIRoutes.v2_categories_path()
])
